import { Brand } from '../entities/Entities';
import { PageRoutes } from './PageRoutes';
import { useFeatureServices } from '../../use-feature-services';
import { BrandRouteSegment } from './BrandRouteSegment';

export type BrandNavigationFunction = (to: PageRoutes, brand?: Brand) => void;

export function useBrandNavigate(): BrandNavigationFunction {
  const { 's2:history': historyService } = useFeatureServices();

  return (to, brand) => {
    if (!brand) {
      const url = historyService.history.location.pathname;
      const brandUrl = url.substring(0, url.lastIndexOf('/'));

      historyService.history.push(`${brandUrl}/${to}`);
      if (typeof window !== 'undefined') {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      return;
    }

    switch (brand) {
      case Brand.Vw: {
        historyService.history.push(`/${BrandRouteSegment.Vw}/${to}`);
        if (typeof window !== 'undefined') {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        break;
      }
      case Brand.Audi: {
        historyService.history.push(`/${BrandRouteSegment.A}/${to}`);
        if (typeof window !== 'undefined') {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        break;
      }
      case Brand.Commercial: {
        historyService.history.push(`/${BrandRouteSegment.C}/${to}`);
        if (typeof window !== 'undefined') {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        break;
      }
      default:
        if (typeof window !== 'undefined') {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        break;
    }
  };
}
